module.exports = __webpack_public_path__ + "cool.0fd03d90.png";